import { configureStore } from '@reduxjs/toolkit';
import { authApi } from './api/authApi';
import { rbacApi } from './api/rbacApi';
import { productionLineApi } from './api/productionLineApi';
import { orderApi } from './api/orderApi';
import { customerPortalApi } from './api/customerPortalApi';
import { adminApi } from './api/adminApi';
import { dashboardApi } from './api/dashboardApi';
import { customerApi } from './api/customerApi';
import { productApi } from './api/productApi';
import { inventoryApi } from './api/inventoryApi';
import { qualityControlApi } from './api/qualityControlApi';
import { maintenanceApi } from './api/maintenanceApi';
import { paymentApi } from './api/paymentApi';
import { supplyChainApi } from './api/supplyChainApi';
import { reportApi } from './api/reportApi';
import { productionQueueApi } from './api/productionQueueApi';
import { productionFlowApi } from './api/productionFlowApi';
import { workOrderApi } from './api/workOrderApi';
import { machineApi } from './api/machineApi';
import { warehouseApi } from './api/warehouseApi';
import { deliveryApi } from './api/deliveryApi';
import { financialApi } from './api/financialApi';

export const store = configureStore({
  reducer: {
    [authApi.reducerPath]: authApi.reducer,
    [rbacApi.reducerPath]: rbacApi.reducer,
    [productionLineApi.reducerPath]: productionLineApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [customerPortalApi.reducerPath]: customerPortalApi.reducer,
    [adminApi.reducerPath]: adminApi.reducer,
    [dashboardApi.reducerPath]: dashboardApi.reducer,
    [customerApi.reducerPath]: customerApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [inventoryApi.reducerPath]: inventoryApi.reducer,
    [qualityControlApi.reducerPath]: qualityControlApi.reducer,
    [maintenanceApi.reducerPath]: maintenanceApi.reducer,
    [paymentApi.reducerPath]: paymentApi.reducer,
    [supplyChainApi.reducerPath]: supplyChainApi.reducer,
    [reportApi.reducerPath]: reportApi.reducer,
    [productionQueueApi.reducerPath]: productionQueueApi.reducer,
    [productionFlowApi.reducerPath]: productionFlowApi.reducer,
    [workOrderApi.reducerPath]: workOrderApi.reducer,
    [machineApi.reducerPath]: machineApi.reducer,
    [warehouseApi.reducerPath]: warehouseApi.reducer,
    [deliveryApi.reducerPath]: deliveryApi.reducer,
    [financialApi.reducerPath]: financialApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      authApi.middleware,
      rbacApi.middleware,
      productionLineApi.middleware,
      orderApi.middleware,
      customerPortalApi.middleware,
      adminApi.middleware,
      dashboardApi.middleware,
      customerApi.middleware,
      productApi.middleware,
      inventoryApi.middleware,
      qualityControlApi.middleware,
      maintenanceApi.middleware,
      paymentApi.middleware,
      supplyChainApi.middleware,
      reportApi.middleware,
      productionQueueApi.middleware,
      productionFlowApi.middleware,
      workOrderApi.middleware,
      machineApi.middleware,
      warehouseApi.middleware,
      deliveryApi.middleware,
      financialApi.middleware,
    ),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
